(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initHero(root) {
      if (!root || root.__cxhReady) return;
      root.__cxhReady = true;

      var media = root.querySelector('.cxh__media');
      var video = root.querySelector('.cxh__video');
      var parallax = root.getAttribute('data-parallax') === 'true' && !reduce;
      var speed = parseFloat(root.getAttribute('data-parallax-speed')) || 5;
      var visible = true;
      var ticking = false;
      var io = null;

      function playVideo() {
        if (!video || reduce || video.offsetParent === null) return;
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      function update() {
        ticking = false;
        if (!parallax || !visible || !media) return;
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        var offset = progress * rect.height * (speed / 100) * 0.95;
        media.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (video) { visible ? playVideo() : video.pause(); }
          if (visible) onScroll();
        });
        io.observe(root);
      } else {
        playVideo();
      }

      if (parallax) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
      if (reduce && video) video.pause();

      root.__cxhCleanup = function () {
        if (io) io.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        root.__cxhReady = false;
      };
    }

    function initAll() {
      var heroes = document.querySelectorAll('[data-cxh]');
      for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (e) {
      initHero(e.target.querySelector('[data-cxh]'));
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-cxh]');
      if (el && el.__cxhCleanup) el.__cxhCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
